import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { getPurchases } from '../actions/purchases'
import { authenticateUser } from '../actions/users'
import { updateSelectedLanguage } from '../actions/new-logo'
import Dashboard from '../components/Dashboard'

const mapStateToProps = (state) => {
  return {
    newLogo: state.newLogo,
    authenticatedUser: state.users.user,
    purchases: state.purchases
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getPurchases: () => {
      dispatch(getPurchases())
    },
    authenticateUser: () => {
      return dispatch(authenticateUser())
      .then(user => {
        return Promise.resolve(user)
      })
      .catch(error => {
        return Promise.reject(error)
      })
    },
    updateLanguage: (lang) => {
      dispatch(updateSelectedLanguage(lang))
    },
    signOut: () => {
      localStorage.removeItem('automagic_token')
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboard))



// WEBPACK FOOTER //
// ./src/containers/Dashboard.js